// @vendors
import { useEffect, useState, useContext } from "react";
import { Form, Select, Modal, ConfigProvider } from "antd";
import Context from "../../../context/appContext";
import {
  getUrl,
  getDependencyValue,
  getUrlFiscal,
  getValueField,
  getValueEqual,
} from "../../../utils/utils";

export default function SelectField({ info, key, form, current }) {
  const [values, setValues] = useState(
    info.data.values ? info.data.values : []
  );
  const validate = info.validate ? info.validate : {};
  const {
    customRequest,
    dataForm: { data, formResponses, hiddenFields, disabledFields },
    checkOption,
    disabledOption,
    setModel,
    setDataForm,
    checked,
  } = useContext(Context);
  const [disabled, setDisabled] = useState(false);
  const [selectParentesco, setSelectParentesco] = useState(false);
  const selectKeys = {
    estadoContratante: true,
    coloniaContratante: true,
    ciudadContratante: true,
    municipioContratante: true,
    regimenFiscalPreferenteContratante: false,
  };
  const keysSelect = {
    estadoContratante: true,
    coloniaContratante: true,
    estadoAsegurado: true,
  };

  const keysSelected = {
    estadoContratante: false,
    coloniaContratante: false,
  };

  const keyStates = {
    estadoAsegurado: "estadoAsegurado",
    estadoContratante: "estadoContratante",
  };
  const keysValues = {
    regimenFiscalPreferenteContratante: true,
    estadoContratante: true,
    coloniaContratante: true,
  };

  const [mediaValue, setMediaValue] = useState(256);

  useEffect(async () => {
    const isSmall = window.matchMedia("(max-height: 660px)").matches;
    setMediaValue(isSmall ? 130 : 256);
  }, []);

  useEffect(async () => {
    const sfield = selectKeys[info.key] ? validadateSelect() : true;
    if (info && sfield) {
      (await (info.customDefaultValue ||
        form.getFieldValue(info.key) ||
        info.value)) && (await getValues());
      getDefaultValue();
    }
  }, []);

  useEffect(async () => {
    const sfield = selectKeys[info.key] ? validadateSelect() : true;
    if (disabledFields[info.key] && sfield) {
      await (info &&
        (info.customDefaultValue ||
          form.getFieldValue(info.key) ||
          info.value));
      if (keysSelected[info.key]) {
        await getValues();
      }
      getDefaultValue();
    }
  }, [disabledFields[info.key]]);

  useEffect(() => {
    if (info && info.key && checkOption && checkOption.length > 0) {
      const name = info.key.indexOf("parentescoAsegurado");
      if (checkOption === "C" && name != -1) {
        if (!selectParentesco) {
          onChange("C");
          form.setFieldsValue({ [info.key]: "C" });
          setSelectParentesco(true);
          setDisabled(true);
        }
      } else {
        setDisabled(false);
      }
    }
    if (keysSelect[info.key]) {
      setDependency();
    }
  }, [checkOption, info]);

  const validadateSelect = () => {
    const codPostal = formResponses.find(
      (x) => x.key === "codigoPostalContratante"
    );
    return codPostal && codPostal.value && codPostal.value !== "";
  };

  const setDependency = async () => {
    let validate = validadateSelect();
    if (!checked && keysSelect[info.key]) {
      if ((validate && validate.length < 5) || !validate) {
        setValues([]);
      }
    }
    if (info.key === "estadoAsegurado") {
      await getValues();
    }
  };

  const getValues = async () => {
    if ((values && values.length === 0) || keysValues[info.key]) {
      const index = formResponses.findIndex((x) => x.key === info.key);
      if (
        info &&
        info.value &&
        info.valuesResponse &&
        info.valuesResponse.length > 0
      ) {
        if (keyStates[info.key]) {
          info.value = info.valuesResponse[0]?.clave;
          form.setFieldsValue({
            [info.key]: info.valuesResponse[0]?.descripcion,
          });
        }
        setValues(info.valuesResponse);
      } else if (
        ((!values[0] || (values[0] && values[0].value !== "Cargando")) &&
          info.dataSrc &&
          info.dataSrc === "json") ||
        !keysSelected[info.key]
      ) {
        const dataLcl = JSON.stringify(info.data.json);
        let opciones_servicio;
        if (info.key === "regimenFiscalPreferenteContratante") {
          const fieldValue = getValueField(
            "tipoDePersonaContratante",
            formResponses
          );
          opciones_servicio = getUrlFiscal(dataLcl, fieldValue);
        } else {
          opciones_servicio = getUrl(dataLcl, formResponses);
        }
        setValues([
          { label: "Cargando...", value: "Cargando", disabled: true },
        ]);
        const response = await customRequest(
          opciones_servicio.url,
          opciones_servicio.headers,
          opciones_servicio.method,
          opciones_servicio.body
        );
        if (response && response.success === false) {
          if (opciones_servicio && !opciones_servicio.body.dependency)
            configModal(
              "Lo sentimos, de momento no contamos con cobertura en tu localidad.",
              "Aceptar",
              "Ops!"
            );
        }

        const valuesResponse =
          response && response.length
            ? response
            : response && response.data && response.data.length
            ? response.data
            : [];

        info.valuesResponse = valuesResponse;

        index !== -1
          ? (formResponses[index].valuesResponse = valuesResponse)
          : formResponses.push(info);
        if (info.key === "estadoAsegurado" && valuesResponse) {
          disabledFields[info.key] = true;
          form.setFieldsValue({ [info.key]: response[0].descripcion });
          onChange(response[0].clave);
        }
        if (info.key === "estadoContratante" && valuesResponse) {
          form.setFieldsValue({ [info.key]: valuesResponse[0]?.descripcion });
          formResponses[index].value = response[0].clave;
        }
        setValues(response && !response.message ? valuesResponse : []);
        setDataForm({ data, formResponses, hiddenFields, disabledFields });
      }
    }
  };

  const configModal = (message, btnOk, title) => {
    Modal.info({
      icon: "",
      title: title,
      className: "modal-confirm",
      closable: false,
      okButtonProps: {
        className: "ant-btn-solid c-2 ant-btn-size-xs margin-s",
      },
      okText: btnOk,
      content: <p>{message}</p>,
      onOk() {},
    });
  };

  const onChange = (event) => {
    if (values.length === 0) {
      setValues([{ label: "Cargando...", value: "Cargando", disabled: true }]);
    }
    setValue(event);
    const dependencyValue = getDependencyValue(current, info.key, event, []);
    if (dependencyValue && dependencyValue.length > 0) {
      dependencyValue.forEach((item) => {
        const keyLcl = Object.keys(item)[0];
        form.setFieldsValue({ [keyLcl]: "" });
        hiddenFields[keyLcl] = item[keyLcl];
      });
      setDataForm({
        data,
        formResponses,
        hiddenFields: hiddenFields,
        disabledFields,
      });
    }
  };

  const setValue = (value) => {
    info.value = value;
    const index = formResponses.findIndex((x) => x.key === info.key);
    index != -1
      ? (formResponses[index].value = value)
      : formResponses.push(info);
    if (info.key === "model") {
      setModel(value);
    }
  };

  const getDefaultValue = async () => {
    const chkData = formResponses.find(
      (item) => item.key === "datosContratanteIgualAsegurado"
    );
    const hasCheckLoadLastStepInfo = current.newItems.find(
      (x) => x && x.key === "datosContratanteIgualAsegurado"
    );
    let value = "";
    if (
      info.customDefaultValue &&
      (!hasCheckLoadLastStepInfo ||
        (hasCheckLoadLastStepInfo && chkData && chkData.value))
    ) {
      const item = formResponses.find((x) => x.key === info.customDefaultValue);
      value = item && item.value ? item.value : "";
      if (!keysSelected[info.key]) {
        value = getValueEqual(item.value, item.valuesResponse);
      }
      disabledFields[info.key] = !selectKeys[info.key]
        ? selectKeys[info.key]
        : true;
    } else if (info && info.value && info.value !== null && info.value !== "") {
      value = info.value;
    }

    if (value && value !== "") {
      form.setFieldsValue({ [info.key]: value });
      onChange(value);
    }
  };

  return (
    <div
      id={info.key}
      style={{
        position: "relative",
        display: hiddenFields[info.key] ? "none" : "block",
      }}
    >
      <Form.Item
        label={info.label}
        name={info.key}
        rules={[
          {
            required:
              hiddenFields[info.key] || disabledFields[info.key] || disabled
                ? false
                : validate.required,
            message: "campo obligatorio",
          },
        ]}
      >
        <Select
          showSearch
          placeholder={info.placeholder}
          notFoundContent={
            info.key === "model"
              ? "Por favor, ingresa un modelo válido"
              : "No se encontraron coincidencias"
          }
          disabled={disabledFields[info.key] || disabled}
          onChange={onChange}
          onFocus={getValues}
          key={key}
          getPopupContainer={() => document.getElementById(info.key)}
          filterOption={(input, option) =>
            option?.props?.children
              .toString()
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
          }
          listHeight={mediaValue}
        >
          {values &&
            values.length > 0 &&
            values.map((item) => (
              <Select.Option
                value={item.clave || item.key || item.value}
                key={item.clave || item.key || item.value}
                disabled={
                  item.disabled || (disabledOption && item.value === "C")
                }
              >
                {item.description || item.descripcion || item.label}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      {info && info.description && (
        <div className="ant-select-description">{info.description}</div>
      )}
    </div>
  );
}
